import React from "react";

const EditorStateContext = React.createContext([]);
export default EditorStateContext;
